@if (anchor) {
  <a [id]="anchor"></a>
}

@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<div class="container" #container>
  <!-- Image map example
  <svg width="100%" [attr.viewBox]="'0 0 ' + attributes.viewBoxWidth + ' ' + attributes.viewBoxHeight">
    <ng-container *ngFor="let area of attributes.areas; let i = index" [ngSwitch]="area.type">
      <svg:rect *ngSwitchCase="'rect'" [class]="area.style" appAreaLink #areas [attr.x]="area.x" [attr.y]="area.y" [attr.width]="area.width"
        [attr.height]="area.height">
      </svg:rect>
      <svg:polygon *ngSwitchCase="'polygon'" [attr.class]="area.style" appAreaLink #areas [attr.points]="area.points">
      </svg:polygon>
      <svg:circle *ngSwitchCase="'circle'" [attr.class]="area.style" appAreaLink #areas [attr.cx]="area.center[0]" [attr.cy]="area.center[1]"
        [attr.r]="area.radius">
      </svg:circle>
    </ng-container>
  </svg>
  -->
  <div class="button-area">
    @for (button of attributes.buttons; track button; let i = $index) {
      <button #buttons
        type="button"
        [attr.class]="button.style"
        [class.active]="activeButtonIndex() === i"
        [style.left.%]="button.center.x" [style.top.%]="button.center.y"
      ></button>
    }
  </div>
  <div class="tooltip-template">
    @for (button of attributes.buttons; track button) {
      <div class="interactive-image--tooltip-content" #contentTemplates>
        @if (isTeaserCardSection(button.content)) {
          <app-teaser-card [section]="button.content"></app-teaser-card>
        }
        @if (isMediumSection(button.content)) {
          <app-medium [attributes]="button.content.attributes"></app-medium>
        }
      </div>
    }
  </div>
  <app-plain-image [section]="attributes.baseImage"/>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
